export const prayerAndTalksConstants = {
	prayerAndTalksSaveRequest: "PRAYER_SAVE_STARTED",
	prayerAndTalksSaveSuccess: "PRAYER_SAVE_COMPLETED",
	prayerAndTalksSaveFailure: "PRAYER_SAVE_FAILED",

	prayerAndTalksDetailRequest: "PRAYER_GET_DETAIL_STARTED",
	prayerAndTalksDetailSuccess: "PRAYER_GET_DETAIL_COMPLETED",
	prayerAndTalksDetailFailure: "PRAYER_GET_DETAIL_FAILED",

	prayerAndTalksGetChannelRequest: "PRAYER_GET_CHANNEL_STARTED",
	prayerAndTalksGetChannelSuccess: "PRAYER_GET_CHANNEL_COMPLETED",
	prayerAndTalksGetChannelFailure: "PRAYER_GET_CHANNEL_FAILED",
}